<template>
<div class="vipExpir">
	<titles></titles>
	<headers :vipState="vipState" :card-state="cardState" @showDialog="showDialog" @showHyxy="showHyxyDialog"></headers>
	<my-privileges :vipState="vipState" :card-state="cardState" @showDialog="showDialog" @showCompensateDialog="showCompensateDialog" @showAuthDialog="showAuthDialog"></my-privileges>
	<job-analysis @showDialog="showDialog" :vipState="vipState"></job-analysis>
	<!-- <privileges  @showDialog="showDialog" @showCompensateDialog="showCompensateDialog" @showAuthDialog="showAuthDialog" :vipState="vipState" :card-state="cardState"></privileges> -->
	<footers></footers>
	<help></help>
	<BuyDialog @closeDialog="closeDialog" :cardChoose="cardChoose" @showHyxy="showHyxyDialog" v-if="show===true"></BuyDialog>
	<!-- 投保提示 -->
	<TbtsDialog @closeDialog="closeDialog" v-if="showTbts"></TbtsDialog>
	<!-- 个人认证 -->
	<AuthDialog @closeDialog="closeDialog" v-if="showAuth"></AuthDialog>
	<ExpriDialog @closeDialog="closeDialog" @buyDialog="showDialog" v-if="showExpri===true"></ExpriDialog>
	<hyxy-dialog v-if="showHyxy" @closeDialog='closeDialog' :stopPrevent="false"></hyxy-dialog>
</div>
</template> 
<script>
import Titles from '../modules/title/Title'
import Headers from '../modules/header/Header'
import MyPrivileges from '../modules/myPrivileges/MyPrivileges'
// import Privileges from '../modules/privileges/Privileges'
import JobAnalysis from '../modules/jobAnalysis/JobAnalysis'
import Help from '../modules/help/Help'
import Footers from '../modules/footer/Footer'
import BuyDialog from '../modules/dialog/BuyDialog'
import TbtsDialog from '../modules/dialog/TbtsDialog' // 投保提示
import AuthDialog from '../modules/dialog/AuthDialog' // 个人认证提示弹窗
import ExpriDialog from '../modules/dialog/ExpriDialog'
import HyxyDialog from '../modules/dialog/HyxyDialog'
import cookie from '../../../js/util.cookies.js'
export default {
	name: 'vipExpir',
	components: {
		Titles,
		Headers,
		MyPrivileges,
		// Privileges,
		JobAnalysis,
		Help,
		Footers,
		BuyDialog,
		TbtsDialog, //投保提示弹窗
		AuthDialog, //个人认证提示弹窗
		ExpriDialog,
		HyxyDialog
	},
	data () {
		return {
			show: false,
			showTbts: false, //投保提示显示
			showHyxy: false,
			showAuth: false,
			cardChoose: 58,
			showExpri: ''
		}
	},
	props: ['vipState', 'cardState'],
	created () {
		this.showExprifn()
	},
	methods: {
		closeDialog () {
			this.show = false
			this.showTbts = false //投保提示弹窗关闭
			this.showAuth = false  // 个人认证提示弹窗
			this.showExpri = false
			this.showHyxy = false
		},
		showDialog (type = 58) {
			this.closeDialog();
			this.cardChoose = type;
			this.show = true;
		},
		// 显示投保提示弹窗
		showCompensateDialog (){
			this.closeDialog()
			this.showTbts = true;
		},
		// 显示个人认证提示弹窗
		showAuthDialog (){
			this.closeDialog()
			this.showAuth = true;
		},
		showHyxyDialog () {
			this.showHyxy = true
		},
		showExprifn () {
			let mydate = new Date()
			// let timeEnd = new Date(mydate.getFullYear() + "/" + (mydate.getMonth() + 1) + "/" + (mydate.getDate() + 1) + " 00:00:00").getTime()
			let timeEnd = new Date(`${mydate.getFullYear()}/${(mydate.getMonth() + 1)}/${(mydate.getDate() + 1)} 00:00:00`).getTime()
			let timecha = "s" + (timeEnd-mydate.getTime()) / 1000
			if (cookie.get('num')) {
				this.showExpri = false
				//cookie.delCookie('num')
			}
			else {
				this.showExpri = true
				cookie.setCookie('num', 1, timecha)
			}
		},
		
	}
}
</script>

<style lang="scss" scope>
@import "../../../assets/css/public.scss"
</style>



// WEBPACK FOOTER //
// VipExpir.vue?10e6805c